(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("47Iat", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0cecb2cf2b44ddd0$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $dfLVZ = parcelRequire("dfLVZ");

var $kqTTL = parcelRequire("kqTTL");

var $2eeTP = parcelRequire("2eeTP");

var $hPa9t = parcelRequire("hPa9t");
const $0cecb2cf2b44ddd0$var$QuickInfoFarm = ()=>{
    const { estate: data } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const [houseNumber, setHouseNumber] = (0, $dTCkE.useState)();
    const [alignment, setAlignment] = (0, $dTCkE.useState)("");
    const [areaText, setAreaText] = (0, $dTCkE.useState)("");
    const [areaValue, setAreaValue] = (0, $dTCkE.useState)("");
    const [isLoaded, setIsLoaded] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        setIsLoaded(false);
        if (data?.mainResidentialBuilding != null && data?.otherResidentialBuildings?.length) setHouseNumber(1 + data?.otherResidentialBuildings?.length);
        if (data?.mainResidentialBuilding?.livingSpace && data?.mainResidentialBuilding?.otherSpace) {
            setAreaText((0, $hPa9t.QuickInfo).LivingAndOtherArea);
            setAreaValue(data?.mainResidentialBuilding?.livingSpace.toString().replace(".", ",") + " + " + data?.mainResidentialBuilding?.otherSpace.toString().replace(".", ","));
        } else if (data?.mainResidentialBuilding?.livingSpace) {
            setAreaText((0, $hPa9t.QuickInfo).LivingSpace);
            setAreaValue(data?.mainResidentialBuilding?.livingSpace.toString().replace(".", ","));
        } else if (data?.mainResidentialBuilding?.otherSpace) {
            setAreaText((0, $hPa9t.QuickInfo).OtherArea);
            setAreaValue(data?.mainResidentialBuilding?.otherSpace.toString().replace(".", ","));
        }
    }, [
        data?.mainResidentialBuilding,
        data?.otherResidentialBuildings
    ]);
    (0, $dTCkE.useEffect)(()=>{
        if (data?.alignment?.length) {
            let alignmentItems = "";
            for(var i = 0; i < data?.alignment?.length; i++)if (alignmentItems.length) alignmentItems += ", " + data?.alignment[i];
            else alignmentItems = data?.alignment[i];
            setAlignment(alignmentItems);
        }
        setIsLoaded(true);
    }, [
        data?.alignment
    ]);
    if (!isLoaded) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $2eeTP.default), {});
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex flex-wrap lg:flex-row lg:flex-auto mt-4 lg:mt-6 px-3 lg:px-7 xxl:px-4 quickInfo font-ic max-w-7xl mx-auto",
        children: [
            areaText != "" && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: areaText,
                comment: data?.buildingInfo?.areaSourceComment,
                value: areaValue + " m\xb2",
                iconUrl: "/Images/Icons/objectPage/livingArea.svg"
            }),
            houseNumber && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).BuildingNo,
                value: houseNumber.toString() + " st",
                iconUrl: "/Images/Icons/objectPage/buildings.svg"
            }),
            data?.propertyArea && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).TotalArea,
                value: data?.propertyArea.toString().replace(".", ",") + " ha",
                iconUrl: "/Images/Icons/objectPage/totalArea.svg"
            }),
            data?.buildingInfo?.buildingYear && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).BuildingYear,
                value: data?.buildingInfo?.buildingYear,
                comment: data?.buildingInfo?.commentaryForBuildingYear,
                iconUrl: "/Images/Icons/objectPage/buildingYear.svg"
            }),
            data?.mainResidentialBuilding?.buildingType && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).Type,
                value: data?.mainResidentialBuilding?.buildingType,
                iconUrl: "/Images/Icons/objectPage/type.svg"
            }),
            alignment && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).Alignment,
                value: alignment,
                iconUrl: "/Images/Icons/objectPage/inriktning.svg"
            }),
            data?.buildingInfo?.propertyUnitDesignation && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.QuickInfo).PropertyUnitDesignation,
                value: data?.buildingInfo?.propertyUnitDesignation,
                iconUrl: "/Images/Icons/objectPage/fastighetsbeteckning.svg"
            }),
            data?.dates?.possibleAccessDate && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dfLVZ.QuickInfoItem), {
                headline: (0, $hPa9t.General).AccessDate,
                value: data?.dates?.possibleAccessDate,
                iconUrl: "/Images/Icons/objectPage/access.svg"
            })
        ]
    });
};
var $0cecb2cf2b44ddd0$export$2e2bcd8739ae039 = $0cecb2cf2b44ddd0$var$QuickInfoFarm;

});

})();
//# sourceMappingURL=QuickInfoFarm.1c8cf325.js.map
